import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import "./check.css";

export default function CheckboxLabels(props) {
  let { label, selected, onChange, id, value, disabled } = props;
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            style={{
              color: `${disabled ? "gray" : selected ? "#FFD700" : "gray"}`,
            }}
          />
        }
        label={<p className="font-normal text-[1rem]">{label}</p>}
        onChange={onChange}
        color="red"
        id={id}
        value={value}
        checked={selected}
        disabled={disabled}
      />
    </FormGroup>
  );
}
